import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../config/config.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentoComprovacaoService {
  private baseUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.baseUrl = this.configService.pessoaApi;
  }

  getUsuariosAssinantes(
      idEntidade?: string,
      nomeUsuario?: string,
      codigoTipoEntidade:string = 'SUP',
      idUsuario?: string,
    ): Observable<string[]> {
      const params = new HttpParams()
        .set('nomeUsuario', nomeUsuario || '')
        .set('idUsuario', idUsuario || '')
      return this.http.get<any[]>(this.baseUrl + `/v1/grupos-entidades-usuarios/usuarios-por-entidade/${idEntidade}?page=0&size=10&sortField=id&sortDirection=asc&codigoTipoEntidade=${codigoTipoEntidade}`, { params });
  }
  getEntidadeAfericao(idEntidade: string) {
    return this.http.get(this.baseUrl + `/v1/afericoes/entidade/${idEntidade}`);
  }

  getTiposParecer(){
      return this.http.get<any[]>(this.baseUrl + `/v1/tipos-pareceres?page=0&size=10&sortDirection=asc&sortField=nome&nome=&descricao=`);
  }
}
